import { vars } from "@common/styles";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin-top: 2.4rem;
  font-size: 1.4rem;
  color: ${vars.colors.grey50};
  word-break: break-word;

  svg {
    flex-shrink: 0;
  }
`;
